import React from 'react';
import Anonymous from './Anonymous';
import Authenticated from './Authenticated';

export interface WidgetProps {
  element: HTMLElement;
}

const Widget: React.SFC<WidgetProps> = props => {
  const variant = props.element.getAttribute('data-variant');
  return (
    <div className="ibm-cloud-sitenav-menu-list--wrapper">
      {variant === 'authenticated' ? <Authenticated /> : <Anonymous />}
    </div>
  );
};

export default Widget;
